// extracted by mini-css-extract-plugin
module.exports = {"container":"_61cc05a7c9--container--31xnW","title":"_61cc05a7c9--title--2nmjb","faq":"_61cc05a7c9--faq--1XYjN"};